// extracted by mini-css-extract-plugin
export default {"main":"not-found_main__hRwiA","header":"not-found_header__rQ9wB","description":"not-found_description__Yx7Lx","btn":"not-found_btn__zSxB6","img":"not-found_img__5H9N-"};